export default __webpack_public_path__ + "static/media/blackgold.263c2548.jpg";